import { render } from "./TaskTypeList.vue?vue&type=template&id=4c70c0ee"
import script from "./TaskTypeList.vue?vue&type=script&lang=js"
export * from "./TaskTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__